const meta = {
  module: "purpose-of-use"
};

export default [
  {
    path: `/purpose-of-use`,
    redirect: "/purpose-of-use/page/1"
  },
  {
    path: `/purpose-of-use/page`,
    redirect: "/purpose-of-use/page/1"
  },
  {
    path: `/purpose-of-use/page/:page`,
    name: "purpose-of-use",
    component: () =>
      import(
        /* webpackChunkName: "purpose-of-use" */ "@/modules/purpose-of-use/views/index.vue"
      ),
    meta: {
      ...meta
    }
  },
  {
    path: `/purpose-of-use/create`,
    name: "purpose-of-use/create",
    component: () =>
      import(
        /* webpackChunkName: "purpose-of-use/create" */ "@/modules/purpose-of-use/views/create.vue"
      ),
    meta: {
      ...meta,
      action: "create"
    }
  },
  {
    path: `/purpose-of-use/edit/:id`,
    name: "purpose-of-use/edit",
    component: () =>
      import(
        /* webpackChunkName: "purpose-of-use/edit" */ "@/modules/purpose-of-use/views/edit.vue"
      ),
    meta: {
      ...meta,
      action: "edit"
    }
  }
];
